/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import Header from './modules/header/header';
import HeaderView from './modules/header/header.view';

export * from './modules/header/components';
export * from './modules/header/header';
export * from './modules/header/header.props.autogenerated';
export * from './modules/header/header.view';
export * from './modules/header/utilities/mock-utilities';

export {
    Header,
    HeaderView
};
